<button *ngIf="showBtn" [ngClass]="btnClass" (click)="print()" [disabled]="btnText === 'Ready to print...'">
	{{ btnText }}
</button>
